"use client";

import { createFileRoute, useParams } from '@tanstack/react-router'
import { FileDetailPage } from '@/src/components/manage/views/FileDetailPage'


export const Route = createFileRoute('/_manage/manage/admin/files/$shareId')({
  component: ViewFilePage,
})

function ViewFilePage() {
  const { shareId } = useParams({ from: '/_manage/manage/admin/files/$shareId' })
  return (
    <FileDetailPage
      shareId={shareId}
      backTo="/manage/admin/files"
      showUploadedBy={true}
    />
  )
}
